import { lazy } from 'react';
export const FrontEndAdminPage = lazy(() => import(/* webpackChunkName: "admin-auth" */ '.'));
export default FrontEndAdminPage;
